import React from 'react';

const BarOverview = ({ language }) => {
  return (
    <section className="container py-5">
 <h2 className="fw-bold mb-4">
  {language === 'en' ? 'Overview' : 'አጠቃላይ እይታ'}
</h2>
      <p>
  {language === 'am'
    ? 'የእኛ ባር እና ሬስቶራንት ከዘመናዊ መገልገያዎች እና ልዩ አገልግሎት ጋር የበለጸገ የምግብ አሰራር ልምድን ይሰጣል። ከመደበኛው የመመገቢያ እስከ መደበኛ የቪአይፒ ዝግጅቶች፣ ወጥ ቤታችን በሰለጠኑ ሼፎች የተዘጋጁ ምግቦችን ያቀርባል።'
    : 'Our Bar & Restaurant provides a rich culinary experience with modern facilities and exceptional service. From casual dining to formal VIP events, our kitchen offers a range of dishes prepared by skilled chefs.'}
</p>

<p>
  {language === 'am'
    ? 'በባር ቤት አገልግሎታችን: የሚሰጡ አገልግሎቶች የአልኮልና ለስላሳ መጠጦች ፣ትኩስ መጠጦች፣ የተለያዩ አይነት ባህላዊ እና ዘመናዊ  ምግቦች።'
    : 'The bar serves a variety of beverages and snacks, complemented by hot drinks and soft drinks. For relaxation or celebration, our services are designed to make you feel at home.'}
</p>

      <h4 className="mt-4">
  {language === 'am' ? 'ዋና ነጥቦች' : 'Highlights'}
</h4>

<div className="table-responsive">
  <table className="table table-bordered mt-3">
    <thead className="table-light">
      <tr>
        <th>{language === 'am' ? 'በባር እና በራሰቶራንት የሚገኙ' : 'Facility'}</th>
        <th>{language === 'am' ? 'መግለጫ' : 'Description'}</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{language === 'am' ? 'የተሟላ ወጥ ቤታችን' : 'Kitchen'}</td>
        <td>{language === 'am' ? 'ንፁህ፣ ዘመናዊ እና በባለሙያ ሰራተኞች የተሟላ' : 'Clean, modern, fully equipped with professional staff'}</td>
      </tr>
      <tr>
        <td>{language === 'am' ? 'የምግብ' : 'Menu'}</td>
        <td>{language === 'am' ? 'ባህላዊ የኢትዮጵያ እና ዓለም አቀፍ ምግቦች' : 'Traditional Ethiopian & International cuisine'}</td>
      </tr>
      <tr>
        <td>{language === 'am' ? 'ባር' : 'Bar'}</td>
        <td>{language === 'am' ? 'የሀገር ውስጥ እና ከውጭ የሚገቡ መጠጦች፣ መክሰስ' : 'Local and imported beverages, snacks, canapés'}</td>
      </tr>
      <tr>
        <td>{language === 'am' ? 'አዝናኝ' : 'Entertainment'}</td>
        <td>{language === 'am' ? 'DSTV እና ዋይ- ፋይ  አገልግሎት፣ ዘና ያለ ድባብ' : 'DSTV service, relaxed atmosphere'}</td>
      </tr>
      <tr>
        <td>{language === 'am' ? 'መጠጥ' : 'Drinks'}</td>
        <td>{language === 'am' ? 'ከውጭ የሚገቡ መጠጦች ፣ ለስላሳ መጠጦች  እና ትኩስ' : 'Hot drinks, soft drinks, and refreshments'}</td>
      </tr>
    </tbody>
  </table>
      </div>
    </section>
  );
};

export default BarOverview;
